export const getRoomsFromUrl = (queryObj) => {
  const rooms = [];
  const queryKeys = Object.keys(queryObj || {});

  for (let i = 0; i < 10; i++) {
    if (queryKeys.includes(`room_${i}_ADT`)) {
      const room = {
        ADT: parseInt(queryObj[`room_${i}_ADT`], 10) || 2,
        CHD: parseInt(queryObj[`room_${i}_CHD`], 10) || 0,
        childAges: [],
      };

      if (room.CHD > 0) {
        for (let j = 0; j < room.CHD; j++) {
          if (queryObj[`room_${i}_CHD_age_${j}`]) {
            room.childAges.push(
              parseInt(queryObj[`room_${i}_CHD_age_${j}`], 10)
            );
          } else {
            room.childAges.push(1);
          }
        }
      }

      rooms.push(room);
    }
  }

  if (rooms.length === 0 && queryObj.ADT) {
    rooms.push({
      ADT: parseInt(queryObj.ADT, 10) || 2,
      CHD: parseInt(queryObj.CHD, 10) || 0,
      childAges: Array(parseInt(queryObj.CHD, 10) || 0).fill(1),
    });
  }

  return rooms.length > 0 ? rooms : undefined;
};
